import { createContext, useContext, useState, ReactNode } from "react";
import { Snackbar, Alert } from "@mui/material";

interface NotifierContextProps {
  showSuccess: (msg: string) => void;
  showError: (msg: string) => void;
}

const NotifierContext = createContext<NotifierContextProps>({
  showSuccess: () => {},
  showError: () => {},
});

export const useNotifier = () => useContext(NotifierContext);

export const NotifierProvider = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState<"success" | "error">("success");
  const [message, setMessage] = useState("");

  const showSuccess = (msg: string) => {
    setSeverity("success");
    setMessage(msg);
    setOpen(true);
  };

  const showError = (msg: string) => {
    setSeverity("error");
    setMessage(msg);
    setOpen(true);
  };

  return (
    <NotifierContext.Provider value={{ showSuccess, showError }}>
      {children}

      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={severity} variant="filled" onClose={() => setOpen(false)}>
          {message}
        </Alert>
      </Snackbar>
    </NotifierContext.Provider>
  );
};
